:host {
  display: block;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: bold;
  color: inherit;
}

.runtime-heading {
  display: flex;
  align-items: center;
}

.runtime-heading__label {
  color: inherit;
  display: flex;
  align-items: center;
}

.runtime-heading__tooltip {
  color: #333333;
  font-weight: normal;
  width: 16px;
  height: 16px;
}

:host(:not([dir="rtl"])) .runtime-heading__tooltip {
  margin-left: 4px;
}

:host([dir="rtl"]) .runtime-heading__tooltip {
  margin-right: 4px;
}